var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375.4 375.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 187.7,
    y1: 375.3,
    x2: 187.8,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f14bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a00ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.8,0C67.9,0,46.9,21.1,46.9,47v70.4h46.9V47h166.2l21.5,21.5v48.9h46.9v-48.9c0-12.5-4.9-24.4-13.7-33.2l-21.5-21.5C284.5,5,272.5,0,260.1,0H93.8ZM281.6,258.2v70.4H93.8v-70.4h187.8ZM328.5,281.6h23.5c13,0,23.5-10.5,23.5-23.5v-70.4c0-25.9-21-46.9-46.9-46.9H46.9c-25.9,0-46.9,21-46.9,46.9v70.4c0,13,10.5,23.5,23.5,23.5h23.5v46.9c0,25.9,21,46.9,46.9,46.9h187.7c25.9,0,46.9-21,46.9-46.9v-46.9h0ZM316.8,181.9c9.7,0,17.6,7.9,17.6,17.6s-7.9,17.6-17.6,17.6-17.6-7.9-17.6-17.6,7.9-17.6,17.6-17.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.cd60980e848b1bad4d1337ad04d2d95b.svg";
export { ForwardRef as ReactComponent };